<p-sidebar [(visible)]="sidebarVisible" position="right" styleClass="notification-sidebar" [showCloseIcon]="false">
  <div class="notifications-container" style="overflow: hidden !important;">
    <div class="header">
      <h3>Notifications</h3>
      <i class="pi pi-times close-icon" (click)="sidebarVisible = false"></i>
    </div>

    <div class="filter-tabs gap-5 d-flex justify-content-between align-items-center">
      <div class="d-flex gap-3">
        <span class="tab" [ngClass]="{ 'active': selectedTab === 'all' }" (click)="switchTab('all')">All</span>
        <span class="tab" [ngClass]="{ 'active': selectedTab === 'read' }" (click)="switchTab('read')">Read</span>
        <span class="tab" [ngClass]="{ 'active': selectedTab === 'unread' }" (click)="switchTab('unread')">Unread</span>
      </div>
      <div class="d-flex gap-3">
        <span class="mark-all" (click)="markAllAsRead()" *ngIf="selectedTab!='read'">Mark all as read</span>
        <span class="mark-all" (click)="deleteAll()">Clear All</span>
      </div>
    </div>

    <div class="notifications" style="overflow: auto !important;">
      <div *ngIf="loading" class="loading-spinner">
        <i class="pi pi-spin pi-spinner"></i>
      </div>
      <ng-container *ngIf="!loading">

        <div *ngFor="let notification of notifications; let i = index" class="notification d-flex justify-content-between" [class]="notification.status=='ACKNOWLEDGED' ? 'unread' : 'read'" 
             (click)="notification.status=='ACKNOWLEDGED' && updateNotification(notification.notificationId,'READ')">
          <!-- <span class="dot" *ngIf="notification.status=='UNREAD'"></span> -->
          <img src="../assets/images/user.png" class="avatar" />
          <div class="content">
            <span class="title">{{ notification.title }}</span>
            <p [innerHTML]="notification.message"></p>
          </div>
          <i class="pi pi-trash delete-icon text-danger" (click)="updateNotification(notification.notificationId,'DELETE'); $event.stopPropagation()"></i>
        </div>
      </ng-container>
    </div>
  </div>
</p-sidebar>

<div class="right-sidebar">
  <i class="pi pi-bell" (click)="showNotification()">
    <span *ngIf="notificationDifference > 0" class="notification-badge">{{ notificationDifference }}</span>
  </i>
  <i class="pi pi-user"></i>
  <i class="pi pi-cog"></i>
  <i class="pi pi-envelope"></i>
</div>